import * as React from 'react';
import { ComponentType } from 'react';
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import ReactTable, { RowInfo } from 'react-table';
import * as ReactTooltip from 'react-tooltip';
import { bindActionCreators } from "redux";
import { InlineLoading } from 'src/components/common';
import { MyTrialsBreadcrumbs } from 'src/helpers/breadcrumbHelper';
import RouterHoc, { IRouterActions, IRouterProps } from 'src/hoc/RouterHoc';
import * as NavigationActions from '../../../actions/navigation';
import * as PagingActions from '../../../actions/pages/pagingPage';
import * as TrialInstitutionsActions from '../../../actions/trialInstitution';
import { FormFilterInput } from '../../../components/form';
import { RestrictedLayout, TruncatedCell } from "../../../components/layouts/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as Dtos from '../../../dtos/Tmd.dtos';
import { RequestState } from "../../../enumerations/RequestState";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { convertToApproximateDateString, convertToShortDateString } from "../../../helpers/date";
import { findLookupValue } from "../../../helpers/lookupHelper";
import { IFormFilter, ITmdState } from "../../../reducers/index";

import './MyTrialsPage.scss';

interface IMyTrialsPageParams {}

interface IMyTrialsPageProps extends IRouterProps<IMyTrialsPageParams> {

    // From state
    formFilter: IFormFilter;
    formLength: number;
    trialInstitutions: Dtos.TrialInstitution[],

    loadingTrialInstitutions: boolean;
    loadTrialInstitutionsSuccess: boolean;
    loadTrialInstitutionsFailure: boolean;

    user: Dtos.User;
    lookups: Dtos.Lookup[];
    permissions?: Dtos.PersonnelTmdPermissions[];

    pageSize: number;
}

interface IMyTrialsPageActions extends IRouterActions {
    clearTrialInstitutions: TrialInstitutionsActions.ITrialInstitutionClearActionCreator;
    loadTrialInstitutions: TrialInstitutionsActions.ITrialInstitutionLoadActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    filter: TrialInstitutionsActions.ITrialInstitutionFilterActionCreator;

    setPageSize: PagingActions.IPagingPageSizeChangedStateActionCreator;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

}

type MyTrialsPageProps = IMyTrialsPageProps & IMyTrialsPageActions;

const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex"
const tableStyleClass: React.CSSProperties = {
    textAlign: "left",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer"
}


class MyTrialsPage extends React.PureComponent<MyTrialsPageProps, any> {

    constructor(props: MyTrialsPageProps) {
        super(props);

        this.clearTrial = this.clearTrial.bind(this);
    }

    componentDidMount() {
        const {
            loadTrialInstitutions,
            setDrawerItems,
            setBreadcrumbs
        } = this.props;
        

        setDrawerItems([]);
        setBreadcrumbs(MyTrialsBreadcrumbs());

        loadTrialInstitutions();
    }

    componentWillReceiveProps(nextProps: MyTrialsPageProps) {
    }

    componentDidUpdate(prevProps: MyTrialsPageProps, prevState) {
        const {
        } = this.props
    }

    componentWillUpdate(nextProps: MyTrialsPageProps) {
    }

    componentWillUnmount() {
        this.clearTrial();
    }

    clearTrial() {
        this.props.clearTrialInstitutions();
    }

    showTrial(): boolean {
        const {
            loadingTrialInstitutions,
            loadTrialInstitutionsSuccess
        } = this.props

        if (!loadingTrialInstitutions && loadTrialInstitutionsSuccess) {
            return true;
        }

        return false;
    }

    render() {

        const {
            loadingTrialInstitutions,
        } = this.props;

        return <RestrictedLayout
            loading={loadingTrialInstitutions}
        >
            {this.renderContent()}
        </RestrictedLayout>;
    }

    renderContent() {

        return <div>
            <div className="row">
                <div className={"col-auto mb-2"}>
                    <h1>Trial Institutions</h1>
                </div>
                <div className="col d-flex justify-content-end align-items-stretch" style={{ height: '38px' }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} hideActiveToggle={true} />
                </div>
            </div>
            {
                !this.showTrial() ?
                    <InlineLoading absoluteCenter={true} size={50}/> :
                    null
            }
            {
                this.showTrial() ?
                    <div className="card">
                        <div className="patient-tables">
                            {
                                this.createTable()
                            }
                        </div>
                    </div> :
                    null
            }
        </div>
    }

    createTable() {

        const {
            trialInstitutions,
            user,
            lookups,
            pageSize,
            setPageSize,
            permissions
        } = this.props

        if (!trialInstitutions || trialInstitutions.length == 0) {
            return (
                <div className='card card-shadow p-3'>
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                        </div>
                        <span>There are currently no trial institutions</span>
                    </div>
                </div>
            )
        }

        const showPagination = trialInstitutions.length > pageSize;
        
        return <div className="table-wrapper">
            <ReactTable
                data={trialInstitutions}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                defaultPageSize={showPagination ? pageSize : trialInstitutions.length}
                pageSize={showPagination ? pageSize : trialInstitutions.length}
                showPagination={showPagination}
                className="-striped -highlight -clickable"
                noDataText="There are currently no trial groups to display"
                resizable={false}
                onPageSizeChange={val => setPageSize(val)}
                getTdProps={(state, rowInfo: RowInfo, column, _instance) => {
                    return {
                        onClick: (e, handleOriginal) => {
                            if (column.id == "personnelCount" && AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPersonnelRoleView, rowInfo.original.trialId, rowInfo.original.institutionId)) {
                                const url: string = "/trials/" + rowInfo.original.trialId + "/trialinstitution/" + rowInfo.original.id + "/personnel";
                                this.props.navigate(url);
                            } else if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionView, rowInfo.original.trialId, rowInfo.original.institutionId)) {
                                const url: string = "/trials/" + rowInfo.original.trialId + "/trialinstitution/" + rowInfo.original.id + "/details";
                                this.props.navigate(url);
                            }

                            if (handleOriginal) {
                                handleOriginal()
                            }

                        }
                    }
                }}
                columns={[
                    {
                        id: "id",
                        Header: ' ',
                        accessor: "id",
                        maxWidth: 50,
                        Cell: (props) => <div className="large-small-icon"><FontAwesomeIcon className="large-icon" icon={FontAwesomeIcons.Light.TRIAL} fixedWidth /><FontAwesomeIcon className="small-icon" icon={FontAwesomeIcons.Light.INSTITUTION} fixedWidth /></div>
                    },
                    {
                        id: "protocolID",
                        Header: 'BCT Number',
                        accessor: 'trial.protocolID',
                        maxWidth: 180,
                    },
                    /*{
                        id: "title",
                        Header: 'Scientific Title',
                        accessor: 'trial.title',
                        Cell: (props) => <TruncatedCell value={props.value} />
                    }, */
                    {
                        id: "shortTitle",
                        Header: 'Short Title',
                        accessor: 'trial.shortTitle',
                        maxWidth: 280,
                        Cell: (props) => <TruncatedCell value={props.value} />
                    },
                    {
                        id: "name",
                        Header: 'Institution',
                        accessor: 'institution.name',
                        Cell: (props) => <TruncatedCell value={props.value} />
                    },
                    {
                        id: "trialInstitutionStatusId",
                        Header: 'Status',
                        accessor: 'trialInstitutionStatusId',
                        Cell: (props) => <div><span data-tip={convertToApproximateDateString(props.value)}>{findLookupValue("TrialInstitution", "TrialInstitutionStatusId", props.value, lookups)}</span><ReactTooltip /></div>
                    },
                    {
                        id: "personnelCount",
                        Header: 'Roles',
                        accessor: 'personnelCount',
                        maxWidth: 80,
                        Cell: (props) =>  <div><span className="text-info"><u>{props.value || "0"}</u></span></div>
                    },
                    {
                        id: "dateActivated",
                        Header: "Date Activated",
                        accessor: "dateActivated",
                        Cell: (props) => <div><span data-tip={convertToApproximateDateString(props.value)}>{convertToShortDateString(props.value)}</span><ReactTooltip /></div>
                    }
                ]}
            />
        </div>
    }
}

const mapStateToProps = (state: ITmdState, ownProps: MyTrialsPageProps): IMyTrialsPageProps => {
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,

        history: ownProps.history,
        location: ownProps.location,

        trialInstitutions: state.trialInstitution.formFilteredData!,
        formFilter: state.trialInstitution.formFilter,
        formLength: state.trialInstitution.formLength,
        lookups: state.trialInstitution.lookups,

        loadingTrialInstitutions: state.trialInstitution.loadState && state.trialInstitution.loadState.status == RequestState.Pending,
        loadTrialInstitutionsSuccess: state.trialInstitution.loadState && state.trialInstitution.loadState.status == RequestState.Success,
        loadTrialInstitutionsFailure: state.trialInstitution.loadState && state.trialInstitution.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        pageSize: state.pagingPage.pageSize
    };
};

const mapDispatchToProps = (dispatch, ownProps: MyTrialsPageProps): IMyTrialsPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadTrialInstitutions: bindActionCreators(TrialInstitutionsActions.LoadTrialInstitution, dispatch),
        clearTrialInstitutions: bindActionCreators(TrialInstitutionsActions.Clear, dispatch),

        filter: bindActionCreators(TrialInstitutionsActions.Filter, dispatch),

        setPageSize: bindActionCreators(PagingActions.PageSizeChanged, dispatch),

        setBreadcrumbs: bindActionCreators(NavigationActions.SetBreadcrumbs, dispatch),
        setDrawerItems: bindActionCreators(NavigationActions.SetDrawerItems, dispatch)
    };
};

export default
    RouterHoc<IMyTrialsPageParams, MyTrialsPageProps>((connect(mapStateToProps, mapDispatchToProps)(MyTrialsPage) as unknown as ComponentType<MyTrialsPageProps>)) as ComponentType<any>;
